import { useEffect } from "react";
import { createPortal } from "react-dom";
import { FiCheck, FiX } from "react-icons/fi";
import { ValutProgressLoader } from "./ValutProgressLoader";

const STATUS_ICON = {
  success: FiCheck,
  error: FiX,
};

const STATUS_ICON_CLASS = {
  success: "valut-progress-overlay__status-icon valut-progress-overlay__status-icon--success",
  error: "valut-progress-overlay__status-icon valut-progress-overlay__status-icon--error",
};

export const ValutProgressOverlay = ({ open, status = "loading", message, description }) => {
  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  if (!open) return null;

  const StatusIcon = STATUS_ICON[status];
  const isLoading = status === "loading";

  return createPortal(
    <div
      className="valut-progress-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="valut-progress-title"
      aria-describedby={description ? "valut-progress-description" : undefined}
    >
      <div className="valut-progress-overlay__backdrop" />

      <div className={`valut-progress-overlay__card valut-progress-overlay__card--${status}`}>
        <div className="valut-progress-overlay__visual" aria-hidden="true">
          {isLoading ? (
            <ValutProgressLoader />
          ) : (
            <div className={`valut-progress-overlay__status valut-progress-overlay__status--${status}`}>
              {StatusIcon && (
                <StatusIcon
                  className={STATUS_ICON_CLASS[status]}
                  size={28}
                  strokeWidth={2.5}
                />
              )}
            </div>
          )}
        </div>

        <div className="valut-progress-overlay__copy" aria-live="polite">
          <p id="valut-progress-title" className="valut-progress-overlay__title">
            {message}
          </p>
          {description && (
            <p id="valut-progress-description" className="valut-progress-overlay__description">
              {description}
            </p>
          )}
        </div>

        {isLoading && (
          <div className="valut-progress-overlay__pulse" aria-hidden="true">
            <span />
            <span />
            <span />
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};
